module.exports = __webpack_public_path__ + "imgs/wheresadweed.ba311a936d4462c625e7c62d2b86ac4f.svg";